const floatCharsPattern = /^\d*[.,]?\d*$/;
const floatNegativeCharsPattern = /^-?\d*[.,]?\d*$/;
/** Returns the normalized value, or null when the input must be rejected. */
function parseFloatInput(raw, { allowNegative = false } = {}) {
    const pattern = allowNegative ? floatNegativeCharsPattern : floatCharsPattern;
    if (!pattern.test(raw))
        return null;
    return raw.replace(',', '.');
}
export { parseFloatInput };
